export default {
  black: {
    100: {
      hex: "#000000",
      pms: "Black 6",
      cmyk: "c60 m40 y40 k100",
      rgb: "r0 g0 b0",
    },
  },
  blue: {
    10: {
      hex: "#edf5ff",
      pms: "657",
      cmyk: "c5 m2 y0 k0",
      rgb: "r237 g245 b255",
    },
    20: {
      hex: "#d0e2ff",
      pms: "2707",
      cmyk: "c18 m7 y0 k0",
      rgb: "r208 g226 b255",
    },
    30: {
      hex: "#a6c8ff",
      pms: "2128",
      cmyk: "c36 m16 y0 k0",
      rgb: "r166 g200 b255",
    },
    40: {
      hex: "#78a9ff",
      pms: "2381",
      cmyk: "c52 m29 y0 k0",
      rgb: "r120 g169 b255",
    },
    50: {
      hex: "#4589ff",
      pms: "2727",
      cmyk: "c64 m39 y0 k0",
      rgb: "r69 g137 b255",
    },
    60: {
      hex: "#0f62fe",
      pms: "2132",
      cmyk: "c80 m60 y0 k0",
      rgb: "r15 g98 b254",
    },
    70: {
      hex: "#0043ce",
      pms: "Dark Blue",
      cmyk: "c91 m76 y1 k0",
      rgb: "r0 g67 b206",
    },
    80: {
      hex: "#002d9c",
      pms: "Reflex Blue",
      cmyk: "c100 m91 y9 k1",
      rgb: "r0 g45 b156",
    },
    90: {
      hex: "#001d6c",
      pms: "280",
      cmyk: "c100 m93 y31 k29",
      rgb: "r0 g29 b108",
    },
    100: {
      hex: "#001141",
      pms: "282",
      cmyk: "c100 m95 y37 k49",
      rgb: "r0 g17 b65",
    },
  },
  "cool gray": {
    10: {
      hex: "#f2f4f8",
      pms: "656",
      cmyk: "c3 m2 y2 k0",
      rgb: "r242 g244 b248",
    },
    20: {
      hex: "#dde1e6",
      pms: "650",
      cmyk: "c13 m9 y10 k0",
      rgb: "r221 g225 b230",
    },
    30: {
      hex: "#c1c7cd",
      pms: "537",
      cmyk: "c25 m20 y21 k0",
      rgb: "r193 g199 b205",
    },
    40: {
      hex: "#a2a9b0",
      pms: "2162",
      cmyk: "c38 m30 y31 k0",
      rgb: "r162 g169 b176",
    },
    50: {
      hex: "#878d96",
      pms: "2163",
      cmyk: "c47 m39 y39 k4",
      rgb: "r135 g141 b150",
    },
    60: {
      hex: "#697077",
      pms: "2164",
      cmyk: "c57 m48 y48 k15",
      rgb: "r105 g112 b119",
    },
    70: {
      hex: "#4d5358",
      pms: "2165",
      cmyk: "c63 m55 y55 k30",
      rgb: "r77 g83 b88",
    },
    80: {
      hex: "#343a3f",
      pms: "2166",
      cmyk: "c68 m61 y60 k49",
      rgb: "r52 g58 b63",
    },
    90: {
      hex: "#21272a",
      pms: "7545",
      cmyk: "c71 m64 y64 k68",
      rgb: "r33 g39 b42",
    },
    100: {
      hex: "#121619",
      pms: "7546",
      cmyk: "c73 m67 y65 k79",
      rgb: "r18 g22 b25",
    },
  },
  cyan: {
    10: {
      hex: "#e5f6ff",
      pms: "9421",
      cmyk: "c9 m0 y0 k0",
      rgb: "r229 g246 b255",
    },
    20: {
      hex: "#bae6ff",
      pms: "2905",
      cmyk: "c26 m0 y0 k0",
      rgb: "r186 g230 b255",
    },
    30: {
      hex: "#82cfff",
      pms: "2190",
      cmyk: "c48 m5 y0 k0",
      rgb: "r130 g207 b255",
    },
    40: {
      hex: "#33b1ff",
      pms: "299",
      cmyk: "c62 m18 y0 k0",
      rgb: "r51 g177 b255",
    },
    50: {
      hex: "#1192e8",
      pms: "2192",
      cmyk: "c72 m32 y0 k0",
      rgb: "r17 g146 b232",
    },
    60: {
      hex: "#0072c3",
      pms: "2194",
      cmyk: "c86 m52 y0 k0",
      rgb: "r0 g114 b195",
    },
    70: {
      hex: "#00539a",
      pms: "2195",
      cmyk: "c96 m71 y5 k0",
      rgb: "r0 g83 b154",
    },
    80: {
      hex: "#003a6d",
      pms: "300",
      cmyk: "c100 m83 y29 k14",
      rgb: "r0 g58 b109",
    },
    90: {
      hex: "#012749",
      pms: "301",
      cmyk: "c100 m84 y40 k39",
      rgb: "r1 g39 b73",
    },
    100: {
      hex: "#061727",
      pms: "302",
      cmyk: "c91 m78 y54 k68",
      rgb: "r6 g23 b39",
    },
  },
  gray: {
    10: {
      hex: "#f4f4f4",
      pms: "Cool Gray 1",
      cmyk: "c4 m2 y1 k0",
      rgb: "r244 g244 b244",
    },
    20: {
      hex: "#e0e0e0",
      pms: "Cool Gray 2",
      cmyk: "c15 m10 y7 k0",
      rgb: "r224 g224 b224",
    },
    30: {
      hex: "#c6c6c6",
      pms: "Cool Gray 3",
      cmyk: "c27 m18 y15 k0",
      rgb: "r198 g198 b198",
    },
    40: {
      hex: "#a8a8a8",
      pms: "Cool Gray 4",
      cmyk: "c40 m30 y26 k0",
      rgb: "r168 g168 b168",
    },
    50: {
      hex: "#8d8d8d",
      pms: "Cool Gray 6",
      cmyk: "c50 m38 y34 k2",
      rgb: "r141 g141 b141",
    },
    60: {
      hex: "#6f6f6f",
      pms: "Cool Gray 7",
      cmyk: "c61 m48 y43 k13",
      rgb: "r111 g111 b111",
    },
    70: {
      hex: "#525252",
      pms: "Cool Gray 8",
      cmyk: "c68 m56 y51 k29",
      rgb: "r82 g82 b82",
    },
    80: {
      hex: "#393939",
      pms: "Cool Gray 9",
      cmyk: "c73 m63 y56 k47",
      rgb: "r57 g57 b57",
    },
    90: {
      hex: "#262626",
      pms: "Cool Gray 10",
      cmyk: "c76 m66 y60 k64",
      rgb: "r38 g38 b38",
    },
    100: {
      hex: "#161616",
      pms: "Cool Gray 11",
      cmyk: "c76 m68 y63 k78",
      rgb: "r22 g22 b22",
    },
  },
  green: {
    10: {
      hex: "#defbe6",
      pms: "9540",
      cmyk: "c10 m0 y11 k0",
      rgb: "r222 g251 b230",
    },
    20: {
      hex: "#a7f0ba",
      pms: "2253",
      cmyk: "c27 m0 y33 k0",
      rgb: "r167 g240 b186",
    },
    30: {
      hex: "#6fdc8c",
      pms: "352",
      cmyk: "c49 m0 y62 k0",
      rgb: "r111 g220 b140",
    },
    40: {
      hex: "#42be65",
      pms: "7479",
      cmyk: "c72 m0 y84 k0",
      rgb: "r66 g190 b101",
    },
    50: {
      hex: "#24a148",
      pms: "7481",
      cmyk: "c81 m10 y100 k0",
      rgb: "r36 g161 b72",
    },
    60: {
      hex: "#198038",
      pms: "7482",
      cmyk: "c86 m25 y100 k12",
      rgb: "r25 g128 b56",
    },
    70: {
      hex: "#0e6027",
      pms: "7733",
      cmyk: "c88 m35 y100 k29",
      rgb: "r14 g96 b39",
    },
    80: {
      hex: "#044317",
      pms: "7734",
      cmyk: "c86 m43 y100 k50",
      rgb: "r4 g67 b23",
    },
    90: {
      hex: "#022d0d",
      pms: "7484",
      cmyk: "c82 m50 y89 k66",
      rgb: "r2 g45 b13",
    },
    100: {
      hex: "#071908",
      pms: "627",
      cmyk: "c75 m56 y75 k80",
      rgb: "r7 g25 b8",
    },
  },
  magenta: {
    10: {
      hex: "#fff0f7",
      pms: "2050",
      cmyk: "c0 m6 y0 k0",
      rgb: "r255 g240 b247",
    },
    20: {
      hex: "#ffd6e8",
      pms: "2036",
      cmyk: "c0 m23 y0 k0",
      rgb: "r255 g214 b232",
    },
    30: {
      hex: "#ffafd2",
      pms: "1905",
      cmyk: "c0 m47 y2 k0",
      rgb: "r255 g175 b210",
    },
    40: {
      hex: "#ff7eb6",
      pms: "190",
      cmyk: "c0 m69 y15 k0",
      rgb: "r255 g126 b182",
    },
    50: {
      hex: "#ee5396",
      pms: "1915",
      cmyk: "c0 m82 y15 k0",
      rgb: "r238 g83 b150",
    },
    60: {
      hex: "#d02670",
      pms: "214",
      cmyk: "c14 m97 y41 k0",
      rgb: "r208 g38 b112",
    },
    70: {
      hex: "#9f1853",
      pms: "227",
      cmyk: "c29 m100 y51 k14",
      rgb: "r159 g24 b83",
    },
    80: {
      hex: "#740937",
      pms: "228",
      cmyk: "c37 m100 y56 k37",
      rgb: "r116 g9 b55",
    },
    90: {
      hex: "#510224",
      pms: "7651",
      cmyk: "c44 m97 y56 k55",
      rgb: "r81 g2 b36",
    },
    100: {
      hex: "#2a0a18",
      pms: "518",
      cmyk: "c60 m78 y61 k77",
      rgb: "r42 g10 b24",
    },
  },
  orange: {
    40: {
      hex: "#ff832b",
      pms: "2655",
      cmyk: "c42 m54 y0 k0",
      rgb: "r255 g131 b43",
    },
  },
  purple: {
    10: {
      hex: "#f6f2ff",
      pms: "9023",
      cmyk: "c2 m5 y0 k0",
      rgb: "r246 g242 b255",
    },
    20: {
      hex: "#e8daff",
      pms: "9361",
      cmyk: "c9 m16 y0 k0",
      rgb: "r232 g218 b255",
    },
    30: {
      hex: "#d4bbff",
      pms: "2635",
      cmyk: "c21 m31 y0 k0",
      rgb: "r212 g187 b255",
    },
    40: {
      hex: "#be95ff",
      pms: "2645",
      cmyk: "c34 m44 y0 k0",
      rgb: "r190 g149 b255",
    },
    50: {
      hex: "#a56eff",
      pms: "2655",
      cmyk: "c42 m54 y0 k0",
      rgb: "r165 g110 b255",
    },
    60: {
      hex: "#8a3ffc",
      pms: "2665",
      cmyk: "c58 m72 y0 k0",
      rgb: "r138 g63 b252",
    },
    70: {
      hex: "#6929c4",
      pms: "2090",
      cmyk: "c74 m90 y0 k0",
      rgb: "r105 g41 b196",
    },
    80: {
      hex: "#491d8b",
      pms: "2091",
      cmyk: "c85 m100 y0 k0",
      rgb: "r73 g29 b139",
    },
    90: {
      hex: "#31135e",
      pms: "2685",
      cmyk: "c94 m100 y30 k20",
      rgb: "r49 g19 b94",
    },
    100: {
      hex: "#1c0f30",
      pms: "275",
      cmyk: "c88 m92 y46 k60",
      rgb: "r28 g15 b48",
    },
  },
  red: {
    10: {
      hex: "#fff1f1",
      pms: "706",
      cmyk: "c0 m6 y2 k0",
      rgb: "r255 g241 b241",
    },
    20: {
      hex: "#ffd7d9",
      pms: "1767",
      cmyk: "c0 m22 y8 k0",
      rgb: "r255 g215 b217",
    },
    30: {
      hex: "#ffb3b8",
      pms: "1775",
      cmyk: "c0 m45 y20 k0",
      rgb: "r255 g179 b184",
    },
    40: {
      hex: "#ff8389",
      pms: "1777",
      cmyk: "c0 m68 y39 k0",
      rgb: "r255 g131 b137",
    },
    50: {
      hex: "#fa4d56",
      pms: "1787",
      cmyk: "c0 m85 y62 k0",
      rgb: "r250 g77 b86",
    },
    60: {
      hex: "#da1e28",
      pms: "185",
      cmyk: "c8 m100 y100 k0",
      rgb: "r218 g30 b40",
    },
    70: {
      hex: "#a2191f",
      pms: "200",
      cmyk: "c23 m100 y100 k18",
      rgb: "r162 g25 b31",
    },
    80: {
      hex: "#750e13",
      pms: "201",
      cmyk: "c31 m100 y98 k43",
      rgb: "r117 g14 b19",
    },
    90: {
      hex: "#520408",
      pms: "188",
      cmyk: "c38 m93 y84 k61",
      rgb: "r82 g4 b8",
    },
    100: {
      hex: "#2d0709",
      pms: "504",
      cmyk: "c54 m77 y68 k69",
      rgb: "r45 g7 b9",
    },
  },
  teal: {
    10: {
      hex: "#d9fbfb",
      pms: "9040",
      cmyk: "c11 m0 y3 k0",
      rgb: "r217 g251 b251",
    },
    20: {
      hex: "#9ef0f0",
      pms: "317",
      cmyk: "c11 m0 y5 k0",
      rgb: "r158 g240 b240",
    },
    30: {
      hex: "#3ddbd9",
      pms: "7471",
      cmyk: "c56 m0 y20 k0",
      rgb: "r61 g219 b217",
    },
    40: {
      hex: "#08bdba",
      pms: "3252",
      cmyk: "c74 m1 y36 k0",
      rgb: "r8 g189 b186",
    },
    50: {
      hex: "#009d9a",
      pms: "326",
      cmyk: "c80 m16 y43 k0",
      rgb: "r0 g157 b154",
    },
    60: {
      hex: "#007d79",
      pms: "7716",
      cmyk: "c87 m32 y53 k10",
      rgb: "r0 g125 b121",
    },
    70: {
      hex: "#005d5d",
      pms: "7717",
      cmyk: "c90 m43 y56 k25",
      rgb: "r0 g93 b93",
    },
    80: {
      hex: "#004144",
      pms: "2238",
      cmyk: "c92 m54 y59 k43",
      rgb: "r0 g65 b68",
    },
    90: {
      hex: "#022b30",
      pms: "3165",
      cmyk: "c92 m62 y59 k57",
      rgb: "r2 g43 b48",
    },
    100: {
      hex: "#081a1c",
      pms: "2217",
      cmyk: "c82 m65 y64 k77",
      rgb: "r8 g26 b28",
    },
  },
  "warm gray": {
    10: {
      hex: "#f7f3f2",
      pms: "Warm Gray 1",
      cmyk: "c2 m3 y3 k0",
      rgb: "r247 g243 b242",
    },
    20: {
      hex: "#e5e0df",
      pms: "Warm Gray 2",
      cmyk: "c11 m10 y10 k0",
      rgb: "r229 g224 b223",
    },
    30: {
      hex: "#cac5c4",
      pms: "Warm Gray 3",
      cmyk: "c25 m22 y21 k0",
      rgb: "r202 g197 b196",
    },
    40: {
      hex: "#ada8a8",
      pms: "Warm Gray 4",
      cmyk: "c37 m31 y31 k0",
      rgb: "r173 g168 b168",
    },
    50: {
      hex: "#8f8b8b",
      pms: "Warm Gray 6",
      cmyk: "c46 m40 y39 k4",
      rgb: "r143 g139 b139",
    },
    60: {
      hex: "#726e6e",
      pms: "Warm Gray 7",
      cmyk: "c55 m50 y48 k15",
      rgb: "r114 g110 b110",
    },
    70: {
      hex: "#565151",
      pms: "Warm Gray 8",
      cmyk: "c61 m57 y55 k30",
      rgb: "r86 g81 b81",
    },
    80: {
      hex: "#3c3838",
      pms: "Warm Gray 9",
      cmyk: "c66 m62 y60 k50",
      rgb: "r60 g56 b56",
    },
    90: {
      hex: "#272525",
      pms: "Warm Gray 11",
      cmyk: "c69 m65 y64 k67",
      rgb: "r39 g37 b37",
    },
    100: {
      hex: "#171414",
      pms: "438",
      cmyk: "c71 m67 y65 k79",
      rgb: "r23 g20 b20",
    },
  },
  white: {
    0: {
      hex: "#ffffff",
      pms: "–",
      cmyk: "c0 m0 y0 k0",
      rgb: "r255 g255 b255",
    },
  },
  yellow: {
    30: {
      hex: "#f1c21b",
      pms: "2645",
      cmyk: "c34 m44 y0 k0",
      rgb: "r241 g194 b27",
    },
  },
};
